module.exports = __webpack_public_path__ + "img/blue-line.0d1f3fd5.svg";